import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Video, Brain, Grid3x3, FileText, CreditCard, ArrowLeft, Settings } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { motion } from 'framer-motion';
import { Button } from './ui/button';

export const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/admin' },
    { icon: Users, label: 'Usuários', path: '/admin/users' },
    { icon: Video, label: 'Vídeos', path: '/admin/videos' },
    { icon: Brain, label: 'Questões Quiz', path: '/admin/quiz' },
    { icon: Grid3x3, label: 'Caça-Palavras', path: '/admin/wordsearch' },
    { icon: FileText, label: 'Página Sobre', path: '/admin/about' },
    { icon: CreditCard, label: 'Pagamentos', path: '/admin/payments' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <motion.div
      initial={{ x: -264 }}
      animate={{ x: 0 }}
      className="hidden md:flex flex-col w-64 h-screen fixed left-0 top-0 border-r border-border bg-white p-6 z-40"
    >
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center text-white font-bold text-lg">
            A
          </div>
          <div>
            <h1 className="text-xl font-bold" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Painel Admin
            </h1>
            <p className="text-xs text-muted-foreground">Beto Carvalho</p>
          </div>
        </div>
        <Button
          onClick={() => navigate('/dashboard')}
          variant="outline"
          size="sm"
          className="w-full mt-3"
          data-testid="admin-back-to-app"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar ao App
        </Button>
      </div>

      <nav className="flex-1 space-y-2">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
              isActive(item.path)
                ? 'bg-orange-500 text-white shadow-lg shadow-orange-500/20'
                : 'text-foreground hover:bg-muted'
            }`}
          >
            <item.icon className="h-5 w-5" />
            <span className="font-medium">{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="border-t border-border pt-4">
        <div className="px-4 py-3 rounded-xl bg-muted">
          <p className="text-xs text-muted-foreground mb-1">Logado como</p>
          <p className="font-medium text-sm">{user?.nome}</p>
        </div>
      </div>
    </motion.div>
  );
};
